import React, { useMemo, useState } from 'react';
import ChatUserCircles from '../components/ChatUserCircles';
import { SUMMER_STAR_COLORS } from '../overlayThemes/summerConstants';

/** Mock chatters for local preview — must not match channelName or COMMON_BOTS in ChatUserCircles */
const MOCK_USERS = [
  'pixel_fan',
  'retro_gamer',
  'chat_lurker',
  'obs_tester',
  'stream_buddy',
  'mod_helper',
  'night_owl',
  'coffee_cat',
  'raid_fan',
  'emote_spam',
  'lurker_pro',
  'hype_train'
];

const TEST_CHANNEL = 'testoverlay';

/**
 * Dev/preview route: bouncing chat stars without Twitch IRC.
 * Open: /overlay-chat-test
 */
export default function OverlayChatStarsTest() {
  const users = useMemo(() => MOCK_USERS, []);
  const [summerStars, setSummerStars] = useState(false);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 0,
        background: 'linear-gradient(180deg, #0f0f18 0%, #1a1a2e 45%, #16213e 100%)',
        fontFamily: "'Press Start 2P', ui-monospace, monospace"
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');
      `}</style>
      <div
        style={{
          position: 'absolute',
          top: 16,
          left: 16,
          zIndex: 200,
          color: '#94a3b8',
          fontSize: 10,
          lineHeight: 1.6,
          maxWidth: 420,
          textShadow: '0 1px 2px rgba(0,0,0,0.8)'
        }}
      >
        <div style={{ color: '#e2e8f0', marginBottom: 8 }}>Chat stars test overlay</div>
        <div>Mock users: {users.length}</div>
        <div style={{ marginTop: 8, opacity: 0.85 }}>
          Route: <span style={{ color: '#7dd3fc' }}>/overlay-chat-test</span>
        </div>
        <div style={{ marginTop: 12, display: 'flex', gap: 8, pointerEvents: 'auto' }}>
          <button
            type="button"
            onClick={() => setSummerStars(false)}
            style={{
              fontFamily: "'Press Start 2P', monospace",
              fontSize: 8,
              padding: '8px 10px',
              cursor: 'pointer',
              border: '2px solid #d4c4a8',
              background: summerStars ? 'rgba(13, 74, 84, 0.6)' : 'rgba(166, 82, 65, 0.9)',
              color: summerStars ? '#d4c4a8' : '#f5f0e6',
            }}
          >
            Flannel
          </button>
          <button
            type="button"
            onClick={() => setSummerStars(true)}
            style={{
              fontFamily: "'Press Start 2P', monospace",
              fontSize: 8,
              padding: '8px 10px',
              cursor: 'pointer',
              border: '2px solid #ffe66d',
              background: summerStars ? 'rgba(0, 119, 182, 0.92)' : 'rgba(8, 38, 58, 0.6)',
              color: summerStars ? '#fff8e7' : '#94a3b8',
            }}
          >
            Summer
          </button>
        </div>
      </div>

      <ChatUserCircles
        users={users}
        channelName={TEST_CHANNEL}
        monitorBotUsername={null}
        starColors={summerStars ? SUMMER_STAR_COLORS : null}
        usernameColor={summerStars ? '#fff8e7' : '#d4c4a8'}
        usernameTextShadow={summerStars ? '1px 1px 0 #0077b6' : '1px 1px 2px rgba(0, 0, 0, 0.8)'}
      />
    </div>
  );
}
